module.exports = __webpack_public_path__ + "static/img/resume-purple.9cafdf0.png";